import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import media from '../../../../assets/media';
import { isCheckPermission } from '../../../base/localuser/functions';
import { PERMISSION } from '../../../base/participants';
import { SwitchChatButton } from '../../../chat';
import {
    AudioMutedButton,
    SpeakerMutedButton,
    VideoMutedButton
} from '../../../device-button';
import { SwitchGroupButton } from '../../../group';
import {
    EtcSwitchButton, OpenVideoButton, SwitchCloseButton,
    SwitchScreenShareButton,
    SwitchShareDocumentButton
} from '../../../options';
import { SwitchParticipantRight } from '../../../participant-right';
import { layoutType } from '../../../video-layout-mode';

function ConferenceFooter({
    screenType, userAgentType, layoutPremission, sharePremission, fullHandler
}) {
    const [isScreenMobile, setIsScreenMobile] = useState(false);
    const [isAgentMobile, setIsAgentMobile] = useState(false);

    useEffect(() => {
        setIsAgentMobile(userAgentType === layoutType.desktop || userAgentType === layoutType.tablet ? false : true);
        setIsScreenMobile(screenType === layoutType.desktop || screenType === layoutType.tablet ? false : true);       
    }, [userAgentType, screenType]);

    return (
        <ConferenceFooterStyled className="footer">
            <div className="option_list left">
                { APP.layout.footer.video && <VideoMutedButton loadMain={true} /> }
                { APP.layout.footer.mic && <AudioMutedButton loadMain={true} /> }
                { APP.layout.footer.speaker && <SpeakerMutedButton isMobile={isAgentMobile} /> }
            </div>

            <div className="option_list middle">
                { !isScreenMobile && <SwitchParticipantRight /> }
                { !isScreenMobile && <SwitchChatButton /> }
                { layoutPremission && <OpenVideoButton isMobile={isScreenMobile} /> }
                { !isScreenMobile && sharePremission && <SwitchScreenShareButton /> }
                { sharePremission && <SwitchShareDocumentButton /> }
                <EtcSwitchButton fullHandler={fullHandler} />
                <SwitchGroupButton />
            </div>

            <div className="option_list right">
                <SwitchCloseButton />
            </div>
        </ConferenceFooterStyled>
    );
}

function _mapStateToProps(state) {
    let layoutPremission = isCheckPermission(state, PERMISSION.LAYOUT);
    let sharePremission = isCheckPermission(state, PERMISSION.SHARE);

    return {
        layoutPremission,
        sharePremission
    };
}

const ConferenceFooterStyled = styled.div`
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    width: 100%;
    height: 73px;    
    min-width: 350px;
    font-size: 14px;
    overflow: hidden;
    font-size: 9px;
    min-width: 350px;

    .option_list {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin: 0;

        & > * { margin: 0;}

        &.middle {
            margin: 0 auto;
        }
    }

    ${media.tabletH`
        padding: 0 10px;
        gap: 8px;

        .option_list {
            gap: 8px;
        }
    `}

    ${media.mobile`
        padding: 0 10px;
        gap: 12px;

        .option_list {
            gap: 12px;
        }
    `}
`;

export default connect(_mapStateToProps)(ConferenceFooter);
